import { Grid, styled } from "@material-ui/core";

export const FullPageHeightGrid = styled(Grid)({
  height: "100vh",
  width: "100%",
  margin: 0,
});
